export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#EF151C" },
        { className: "secondary-bg-colour", colour: "#2D343B" },
        { className: "navbar-bg-colour", colour: "#2D343B" }
    ],
    text: [
        { className: "primary-text", colour: "#FFFFFF" },
        { className: "secondary-text", colour: "#EF151C" }
    ],
    borders: [
        { className: "primary-border-colour", colour: "#EF151C" },
    ]
};
